import { useState, useEffect } from "react";
import CrmNewDesktop from "../CrmNew/CrmNewDesktop.js";
import CrmNewMobile from "../CrmNew/CrmNewMobile.js";

const CrmNew = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      const width = window.innerWidth;
      const userAgent = navigator.userAgent;

      const isMobileWidth = width < 768;

      const isMobileUserAgent =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );

      return isMobileWidth || isMobileUserAgent;
    };

    setIsMobile(checkIsMobile());

    const handleResize = () => {
      setIsMobile(checkIsMobile());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile ? <CrmNewMobile /> : <CrmNewDesktop />;
};

export default CrmNew;
